let time = new Date().getTime()

const setActivityTime = (_) => {
  time = new Date().getTime()
}

document.body.addEventListener('mousemove', setActivityTime)
document.body.addEventListener('keypress', setActivityTime)

const refresh = () => {
  if (new Date().getTime() - time >= 10 * 60 * 1000) {
    window.location.reload(true)
  } else {
    setTimeout(refresh, 10000)
  }
}

setTimeout(refresh, 10000)

// A deploy replaces the hashed chunks, so a tab opened before it can no longer load them.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})
